import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

const marks = [
    {
        value: 0,
        label: "Now"
    },
    {
        value: 1,
        label: "1hr"
    },
    {
        value: 2,
        label: "2hrs"
    },
    {
        value: 4,
        label: "4hrs"
    },
    {
        value: 6,
        label: "6hrs"
    },
    {
        value: 8,
        label: "8hrs"
    },
    {
        value: 10,
        label: "10hrs"
    },
    {
        value: 12,
        label: "12hrs"
    }
]

export default function CongestionRegionSliderControl(props) {
    const setLayersOn = props.setLayersOn;
    const [level, setLevel] = React.useState(0);
    const setCongestionRegionsOn = props.setCongestionRegionsOn;

    const handleChange = (e, value, old) => {
        if(value !== old) {
            setLevel(value);
            setLayersOn(layers => {
                if(layers['Regional Congestion']) {
                    let newLayersContext = { ...layers };
                    layers['Regional Congestion'].query = value;
                    return newLayersContext;
                }
            })
        }
    }

    const onClose = (e) => {
        setCongestionRegionsOn(false);
        setLayersOn(layers => {
            if(layers['Regional Congestion']) {
                let newLayersContext = { ...layers };
                layers['Regional Congestion'].enabled = false;
                return newLayersContext;
            }
        })
    }

    return (
        <Box sx={{maxWidth:"85%", backgroundColor: "white", pr:3, pl:3, textAlign:"center", float:"right", width:400, mr:2, mt:2, borderRadius:2, position:"relative"}}> 
            <Typography variant="body1" sx={{color: "black"}}>Congestion Predictions</Typography>
            <IconButton size="small"
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 1,
                        top: 1,
                        maxHeight:17,
                        color: (theme) => theme.palette.grey[500],                       
                    }}
                >
                    <CloseIcon />
                </IconButton>
            <Slider
                sx={{
                '& .MuiSlider-markLabel': {
                    color: "black"
                }
                }}
                aria-label="Congestion Predictions Slider"
                defaultValue={0}
                valueLabelDisplay="auto"
                marks={marks}
                min={0}
                max={12}
                step={null}
                onChange={(e, value) => handleChange(e, value, level)}
            />
        </Box>

    );
}